export const API_URL = "https://cpetwise-uw.medibyt.com/api";
// export const API_URL = "https://cpetwise-api.medibyt.com/api";
// export const API_URL = "http://localhost:2222/api";

// AUTH
export const LOGIN_ENDPOINT = "/login";
export const RESET_PASSWORD_ENDPOINT = "/reset-password";
export const VERIFY_MFA_ENDPOINT = "/verify-mfa";
export const LOGOUT_ENDPOINT = "/logout";
export const USER_ENDPOINT = "/user";

// OPEN TEST
export const TEST_ENDPOINT = "/test";
export const FILE_VALIDATION_ENDPOINT = "/test/validation";
export const PRESIGNED_BUCKET_URL_ENDPOINT = "/test/presigned-bucket-url";

// DATA INPUT
export const PERSONAL_DATA_ENDPOINT = "/test";
export const PERSONAL_DATA_VALIDATION_ENDPOINT = "/personal-data/validation";
export const ADDITIONAL_PERSONAL_DATA_ENDPOINT = "/test/additional";
export const ADDITIONAL_PERSONAL_DATA_VALIDATION_ENDPOINT =
    "/personal-data/additional/validation";
export const MEDICAL_INFORMATION_ENDPOINT = "/medical-values";
export const ADDITIONAL_MEDICAL_INFORMATION_ENDPOINT =
    "/medical-values/additional";
export const CPET_INFO_ENDPOINT = "/cpet-info";
export const SYMPTOMS_ENDPOINT = "/symptoms";
export const FV_LOOPS_ENDPOINT = "/fv-loops";
export const FV_LOOPS_VALIDATION_ENDPOINT = "/fv-loops/validation";
export const PRE_SPIROMETRY_ENDPOINT = "/pre-spirometry";
export const POST_SPIROMETRY_ENDPOINT = "/post-spirometry";
export const BLOOD_TEST_ENDPOINT = "/blood-test";
export const BLOOD_TEST_VALIDATION_ENDPOINT = `${BLOOD_TEST_ENDPOINT}/validation`;
export const REST_BLOOD_TEST_ENDPOINT = "/rest-blood-test";
export const EXERCISE_BLOOD_TEST_ENDPOINT = "/exercise-blood-test";
export const CONFIRM_DATA_INPUT = "/data-input/confirm";
export const CANCEL_DATA_INPUT = "/data-input/cancel";

// INTERPRETATION
export const INTERPRETATION_ENDPOINT = "/interpretation";
export const INTERPRETATION_GRAPHS_ENDPOINT = "/interpretation/graphs";
export const INTERPRETATION_TABLE_ENDPOINT = "/interpretation/parameters";
export const INTERPRETATION_CONFIRM_ENDPOINT = "/interpretation/confirm";
export const INTERPRETATION_CANCEL_ENDPOINT = "/interpretation/cancel";

// INBAR 12
export const INBAR_12_ENDPOINT = "/inbar12";

export const WASSERMAN_9_ENDPOINT = "/wasserman9";

// SUMMARY TABLES
export const PEAK_VALUES_ENDPOINT = "/peak-values";
export const SLOPES_ENDPOINT = "/slopes";
export const RESPONSES_ENDPOINT = "/responses";

// ANAEROBIC THRESHOLD
export const ANAEROBIC_THRESHOLD_GRAPHS_ENDPOINT = "/vat/graphs";
export const ANAEROBIC_THRESHOLD_TABLES_ENDPOINT = "/vat/values";
export const ANAEROBIC_THRESHOLD_GRAPHS_RECALCULATE_ENDPOINT =
    "/vat/graphs/recalculate";
export const ANAEROBIC_THRESHOLD_CONFIRM_EDITS = "/vat/graphs/confirm";
export const ANAEROBIC_THRESHOLD_CANCEL_EDITS = "/vat/graphs/cancel";

// HISTORIC DATA
export const HISTORIC_DATA_ENDPOINT = "/test/previous";

// SMOOTHING
export const SMOOTH_RATE = "/smooth-rate";

// REPORT
export const REPORT_ENDPOINT = "/report";

// NAVBAR
export const RAW_DATA_ENDPOINT = "/raw-data-with-labels";

// ANALYTICS
export const ANALYTICS_ENDPOINT = "/analytics";
